import { withParams } from 'vuelidate';

/**
 * Validates whether the date value is (inclusive) between the dates minDateStr and maxDateStr
 * @param value Date value of validated element
 * @param minDateStr Lower bound date string in the format YYYY-MM-DD
 * @param maxDateStr Upper bound date string in the format YYYY-MM-DD
 * @returns {boolean} True if value is between minDate and maxDate
 */
function isDateBetween(value, minDateStr, maxDateStr) {
  const valueDate = new Date(value).getTime();
  const minDate = new Date(minDateStr).getTime();
  const maxDate = new Date(maxDateStr).getTime();

  return valueDate >= minDate && valueDate <= maxDate;
}

export default (minDate, maxDate) =>
  withParams(
    { type: 'dateBetween', min: minDate, max: maxDate },
    (value) => {
      if (value === undefined || value === null || value === '') {
        return true;
      }

      return isDateBetween(value, minDate, maxDate);
    },
  );



// WEBPACK FOOTER //
// ./src/utils/validators/DateBetween.js